export const classifyData = [
  {
    id: 1,
    item_id: "1-0-1-1",
    item_name: "对1名精零1级干员使用1次基础作战记录",
    item_value: -61,
    rarity: 1,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 2,
    item_id: "1-0-1-2",
    item_name: "对1名精零1级干员使用1次初级作战记录",
    item_value: -125,
    rarity: 2,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 3,
    item_id: "1-0-5-1",
    item_name: "对1名精零5级干员使用1次基础作战记录",
    item_value: -69,
    rarity: 1,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 4,
    item_id: "1-0-5-2",
    item_name: "对1名精零5级干员使用1次初级作战记录",
    item_value: -141,
    rarity: 2,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 5,
    item_id: "1-0-10-1",
    item_name: "对1名精零10级干员使用1次基础作战记录",
    item_value: -79,
    rarity: 1,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 6,
    item_id: "1-0-10-2",
    item_name: "对1名精零10级干员使用1次初级作战记录",
    item_value: -159,
    rarity: 2,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 7,
    item_id: "1-0-15-1",
    item_name: "对1名精零15级干员使用1次基础作战记录",
    item_value: -88,
    rarity: 1,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 8,
    item_id: "1-0-15-2",
    item_name: "对1名精零15级干员使用1次初级作战记录",
    item_value: -177,
    rarity: 2,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 9,
    item_id: "1-0-20-1",
    item_name: "对1名精零20级干员使用1次基础作战记录",
    item_value: -122,
    rarity: 1,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 10,
    item_id: "1-0-20-2",
    item_name: "对1名精零20级干员使用1次初级作战记录",
    item_value: -251,
    rarity: 2,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 11,
    item_id: "1-0-25-1",
    item_name: "对1名精零25级干员使用1次基础作战记录",
    item_value: -162,
    rarity: 1,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 12,
    item_id: "1-0-25-2",
    item_name: "对1名精零25级干员使用1次初级作战记录",
    item_value: -324,
    rarity: 2,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 13,
    item_id: "1-0-30-1",
    item_name: "对1名精零30级干员使用1次基础作战记录",
    item_value: -202,
    rarity: 1,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 14,
    item_id: "1-0-30-2",
    item_name: "对1名精零30级干员使用1次初级作战记录",
    item_value: -404,
    rarity: 2,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 15,
    item_id: "1-0-35-1",
    item_name: "对1名精零35级干员使用1次基础作战记录",
    item_value: -242,
    rarity: 1,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 16,
    item_id: "1-0-35-2",
    item_name: "对1名精零35级干员使用1次初级作战记录",
    item_value: -484,
    rarity: 2,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 17,
    item_id: "1-0-40-1",
    item_name: "对1名精零40级干员使用1次基础作战记录",
    item_value: -282,
    rarity: 1,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 18,
    item_id: "1-0-40-2",
    item_name: "对1名精零40级干员使用1次初级作战记录",
    item_value: -564,
    rarity: 2,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 19,
    item_id: "1-0-45-1",
    item_name: "对1名精零45级干员使用1次基础作战记录",
    item_value: -322,
    rarity: 1,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 20,
    item_id: "1-0-45-2",
    item_name: "对1名精零45级干员使用1次初级作战记录",
    item_value: -644,
    rarity: 2,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 21,
    item_id: "1-1-1-1",
    item_name: "对1名精一1级干员使用1次基础作战记录",
    item_value: -81,
    rarity: 1,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 22,
    item_id: "1-1-1-2",
    item_name: "对1名精一1级干员使用1次初级作战记录",
    item_value: -165,
    rarity: 2,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 23,
    item_id: "1-1-5-1",
    item_name: "对1名精一5级干员使用1次基础作战记录",
    item_value: -89,
    rarity: 1,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 24,
    item_id: "1-1-5-2",
    item_name: "对1名精一5级干员使用1次初级作战记录",
    item_value: -179,
    rarity: 2,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 25,
    item_id: "1-1-10-1",
    item_name: "对1名精一10级干员使用1次基础作战记录",
    item_value: -100,
    rarity: 1,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 26,
    item_id: "1-1-10-2",
    item_name: "对1名精一10级干员使用1次初级作战记录",
    item_value: -199,
    rarity: 2,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 27,
    item_id: "1-1-15-1",
    item_name: "对1名精一15级干员使用1次基础作战记录",
    item_value: -111,
    rarity: 1,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 28,
    item_id: "1-1-15-2",
    item_name: "对1名精一15级干员使用1次初级作战记录",
    item_value: -222,
    rarity: 2,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 29,
    item_id: "1-1-20-1",
    item_name: "对1名精一20级干员使用1次基础作战记录",
    item_value: -122,
    rarity: 1,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 30,
    item_id: "1-1-20-2",
    item_name: "对1名精一20级干员使用1次初级作战记录",
    item_value: -244,
    rarity: 2,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 31,
    item_id: "1-1-25-1",
    item_name: "对1名精一25级干员使用1次基础作战记录",
    item_value: -133,
    rarity: 1,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 32,
    item_id: "1-1-25-2",
    item_name: "对1名精一25级干员使用1次初级作战记录",
    item_value: -265,
    rarity: 2,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 33,
    item_id: "1-1-30-1",
    item_name: "对1名精一30级干员使用1次基础作战记录",
    item_value: -144,
    rarity: 1,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 34,
    item_id: "1-1-30-2",
    item_name: "对1名精一30级干员使用1次初级作战记录",
    item_value: -288,
    rarity: 2,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 35,
    item_id: "1-1-35-1",
    item_name: "对1名精一35级干员使用1次基础作战记录",
    item_value: -155,
    rarity: 1,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 36,
    item_id: "1-1-35-2",
    item_name: "对1名精一35级干员使用1次初级作战记录",
    item_value: -310,
    rarity: 2,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 37,
    item_id: "1-1-40-1",
    item_name: "对1名精一40级干员使用1次基础作战记录",
    item_value: -166,
    rarity: 1,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 38,
    item_id: "1-1-40-2",
    item_name: "对1名精一40级干员使用1次 初级作战记录",
    item_value: -332,
    rarity: 2,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 39,
    item_id: "1-1-45-1",
    item_name: "对1名精一45级干员使用1次基础作战记录",
    item_value: -177,
    rarity: 1,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 40,
    item_id: "1-1-45-2",
    item_name: "对1名精一45级干员使用1次初级作战记录",
    item_value: -354,
    rarity: 2,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 41,
    item_id: "1-1-50-1",
    item_name: "对1名精一50级干员使用1次基础作战记录",
    item_value: -188,
    rarity: 1,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 42,
    item_id: "1-1-50-2",
    item_name: "对1名精一50级干员使用1次初级作战记录",
    item_value: -376,
    rarity: 2,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 43,
    item_id: "1-1-55-1",
    item_name: "对1名精一55级干员使用1次基础作战记录",
    item_value: -199,
    rarity: 1,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 44,
    item_id: "1-1-55-2",
    item_name: "对1名精一55级干员使用1次初级作战记录",
    item_value: -398,
    rarity: 2,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 45,
    item_id: "1-1-60-1",
    item_name: "对1名精一60级干员使用1次基础作战记录",
    item_value: -210,
    rarity: 1,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 46,
    item_id: "1-1-60-2",
    item_name: "对1名精一60级干员使用1次初级作战记录",
    item_value: -420,
    rarity: 2,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 47,
    item_id: "1-1-65-1",
    item_name: "对1名精一65级干员使用1次基础作战记录",
    item_value: -221,
    rarity: 1,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 48,
    item_id: "1-1-65-2",
    item_name: "对1名精一65级干员使用1次初级作战记录",
    item_value: -442,
    rarity: 2,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 49,
    item_id: "1-1-70-1",
    item_name: "对1名精一70级干员使用1次基础作战记录",
    item_value: -232,
    rarity: 1,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 50,
    item_id: "1-1-70-2",
    item_name: "对1名精一70级干员使用1次初级作战记录",
    item_value: -464,
    rarity: 2,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 51,
    item_id: "1-2-1-1",
    item_name: "对1名精二1级干员使用1次基础作战记录",
    item_value: -80,
    rarity: 1,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 52,
    item_id: "1-2-1-2",
    item_name: "对1名精二1级干员使用1次初级作战记录",
    item_value: -162,
    rarity: 2,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 53,
    item_id: "1-2-5-1",
    item_name: "对1名精二5级干员使用1次基础作战记录",
    item_value: -87,
    rarity: 1,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 54,
    item_id: "1-2-5-2",
    item_name: "对1名精二5级干员使用1次初级作战记录",
    item_value: -175,
    rarity: 2,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 55,
    item_id: "1-2-10-1",
    item_name: "对1名精二10级干员使用1次基础作战记录",
    item_value: -96,
    rarity: 1,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 56,
    item_id: "1-2-10-2",
    item_name: "对1名精二10级干员使用1次初级作战记录",
    item_value: -192,
    rarity: 2,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 57,
    item_id: "1-2-15-1",
    item_name: "对1名精二15级干员使用1次基础作战记录",
    item_value: -105,
    rarity: 1,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 58,
    item_id: "1-2-15-2",
    item_name: "对1名精二15级干员使用1次初级作战记录",
    item_value: -210,
    rarity: 2,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 59,
    item_id: "1-2-20-1",
    item_name: "对1名精二20级干员使用1次基础作战记录",
    item_value: -114,
    rarity: 1,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 60,
    item_id: "1-2-20-2",
    item_name: "对1名精二20级干员使用1次初级作战记录",
    item_value: -228,
    rarity: 2,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 61,
    item_id: "1-2-25-1",
    item_name: "对1名精二25级干员使用1次基础作战记录",
    item_value: -123,
    rarity: 1,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 62,
    item_id: "1-2-25-2",
    item_name: "对1名精二25级干员使用1次初级作战记录",
    item_value: -246,
    rarity: 2,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 63,
    item_id: "1-2-30-1",
    item_name: "对1名精二30级干员使用1次基础作战记录",
    item_value: -132,
    rarity: 1,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 64,
    item_id: "1-2-30-2",
    item_name: "对1名精二30级干员使用1次初级作战记录",
    item_value: -264,
    rarity: 2,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 65,
    item_id: "1-2-35-1",
    item_name: "对1名精二35级干员使用1次基础作战记录",
    item_value: -141,
    rarity: 1,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 66,
    item_id: "1-2-35-2",
    item_name: "对1名精二35级干员使用1次初级作战记录",
    item_value: -282,
    rarity: 2,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 67,
    item_id: "1-2-40-1",
    item_name: "对1名精二40级干员使用1次基础作战记录",
    item_value: -150,
    rarity: 1,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 68,
    item_id: "1-2-40-2",
    item_name: "对1名精二40级干员使用1次初级作战记录",
    item_value: -300,
    rarity: 2,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 69,
    item_id: "1-2-45-1",
    item_name: "对1名精二45级干员使用1次基础作战记录",
    item_value: -159,
    rarity: 1,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 70,
    item_id: "1-2-45-2",
    item_name: "对1名精二45级干员使用1次初级作战记录",
    item_value: -318,
    rarity: 2,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 71,
    item_id: "1-2-50-1",
    item_name: "对1名精二50级干员使用1次基础作战记录",
    item_value: -168,
    rarity: 1,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 72,
    item_id: "1-2-50-2",
    item_name: "对1名精二50级干员使用1次初级作战记录",
    item_value: -336,
    rarity: 2,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 73,
    item_id: "1-2-55-1",
    item_name: "对1名精二55级干员使用1次基础作战记录",
    item_value: -177,
    rarity: 1,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 74,
    item_id: "1-2-55-2",
    item_name: "对1名精二55级干员使用1次初级作战记录",
    item_value: -354,
    rarity: 2,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 75,
    item_id: "1-2-60-1",
    item_name: "对1名精二60级干员使用1次基础作战记录",
    item_value: -186,
    rarity: 1,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 76,
    item_id: "1-2-60-2",
    item_name: "对1名精二60级干员使用1次 初级作战记录",
    item_value: -372,
    rarity: 2,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 77,
    item_id: "1-2-65-1",
    item_name: "对1名精二65级干员使用1次基础作战记录",
    item_value: -195,
    rarity: 1,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 78,
    item_id: "1-2-65-2",
    item_name: "对1名精二65级干员使用1次初级作战记录",
    item_value: -390,
    rarity: 2,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 79,
    item_id: "1-2-70-1",
    item_name: "对1名精二70级干员使用1次基础作战记录",
    item_value: -204,
    rarity: 1,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 80,
    item_id: "1-2-70-2",
    item_name: "对1名精二70级干员使用1次初级作战记录",
    item_value: -408,
    rarity: 2,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 81,
    item_id: "1-2-75-1",
    item_name: "对1名精二75级干员使用1次基础作战记录",
    item_value: -213,
    rarity: 1,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 82,
    item_id: "1-2-75-2",
    item_name: "对1名精二75级干员使用1次初级作战记录",
    item_value: -426,
    rarity: 2,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 83,
    item_id: "1-2-80-1",
    item_name: "对1名精二80级干员使用1次基础作战记录",
    item_value: -223,
    rarity: 1,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 84,
    item_id: "1-2-80-2",
    item_name: "对1名精二80级干员使用1次初级作战记录",
    item_value: -445,
    rarity: 2,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 85,
    item_id: "1-2-85-1",
    item_name: "对1名精二85级干员使用1次基础作战记录",
    item_value: -234,
    rarity: 1,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 86,
    item_id: "1-2-85-2",
    item_name: "对1名精二85级干员使用1次初级作战记录",
    item_value: -467,
    rarity: 2,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 87,
    item_id: "2-3-6",
    item_name: "三星通关6理智关卡(例如1-7)",
    item_value: 72,
    rarity: 5,
    type: "3_star",
    consume: 6,
  },
  {
    id: 88,
    item_id: "2-3-9",
    item_name: "三星通关9理智关卡",
    item_value: 108,
    rarity: 5,
    type: "3_star",
    consume: 9,
  },
  {
    id: 89,
    item_id: "2-3-10",
    item_name: "三星通关10理智关卡",
    item_value: 120,
    rarity: 5,
    type: "3_star",
    consume: 10,
  },
  {
    id: 90,
    item_id: "2-3-15",
    item_name: "三星通关15理智关卡",
    item_value: 180,
    rarity: 5,
    type: "3_star",
    consume: 15,
  },
  {
    id: 91,
    item_id: "2-3-18",
    item_name: "三星通关18理智关卡(等效3次1-7)",
    item_value: 216,
    rarity: 5,
    type: "3_star",
    consume: 18,
  },
  {
    id: 92,
    item_id: "2-3-21",
    item_name: "三星通关21理智关卡",
    item_value: 252,
    rarity: 5,
    type: "3_star",
    consume: 21,
  },
  {
    id: 93,
    item_id: "2-2-6",
    item_name: "二星通关6理智关卡",
    item_value: 60,
    rarity: 5,
    type: "2_star",
    consume: 6,
  },
  {
    id: 94,
    item_id: "2-2-9",
    item_name: "二星通关9理智关卡",
    item_value: 90,
    rarity: 5,
    type: "2_star",
    consume: 9,
  },
  {
    id: 95,
    item_id: "2-2-10",
    item_name: "二星通关10理智关卡",
    item_value: 100,
    rarity: 5,
    type: "2_star",
    consume: 10,
  },
  {
    id: 96,
    item_id: "2-2-15",
    item_name: "二星通关15理智关卡",
    item_value: 150,
    rarity: 5,
    type: "2_star",
    consume: 15,
  },
  {
    id: 97,
    item_id: "2-2-18",
    item_name: "二星通关18理智关卡",
    item_value: 180,
    rarity: 5,
    type: "2_star",
    consume: 18,
  },
  {
    id: 98,
    item_id: "2-2-21",
    item_name: "二星通关21理智关卡",
    item_value: 210,
    rarity: 5,
    type: "2_star",
    consume: 21,
  },
  {
    id: 99,
    item_id: "4-1",
    item_name: "活动商店使用1代币换取20龙门币",
    item_value: 20,
    rarity: 5,
    type: "store_20",
    consume: 0,
  },
  {
    id: 100,
    item_id: "3-1",
    item_name: "基建加工站合成绿色材料",
    item_value: -100,
    rarity: 1,
    type: "material",
    consume: 0,
  },
  {
    id: 101,
    item_id: "3-2",
    item_name: "基建加工站合成蓝色材料",
    item_value: -200,
    rarity: 2,
    type: "material",
    consume: 0,
  },
  {
    id: 102,
    item_id: "3-3",
    item_name: "基建加工站合成紫色材料",
    item_value: -300,
    rarity: 3,
    type: "material",
    consume: 0,
  },
  {
    id: 103,
    item_id: "3-4",
    item_name: "基建加工站合成橙色材料",
    item_value: -400,
    rarity: 5,
    type: "material",
    consume: 0,
  },
  {
    id: 104,
    item_id: "4-2",
    item_name: "危机合约商店使用1代币换取70龙门币",
    item_value: 70,
    rarity: 5,
    type: "store_70",
    consume: 0,
  },
  {
    id: 105,
    item_id: "4-3",
    item_name: "活动商店使用1代币换取10龙门币",
    item_value: 10,
    rarity: 5,
    type: "store_10",
    consume: 0,
  },
  {
    id: 106,
    item_id: "2-4-25",
    item_name: "代理剿灭25理智获取250龙门币",
    item_value: 250,
    rarity: 5,
    type: "ext_25",
    consume: 25,
  },
  {
    id: 107,
    item_id: "2-3-20",
    item_name: "三星通关20理智关卡",
    item_value: 240,
    rarity: 5,
    type: "3_star",
    consume: 20,
  },
  {
    id: 108,
    item_id: "2-3-25",
    item_name: "三星通关25理智关卡",
    item_value: 300,
    rarity: 5,
    type: "3_star",
    consume: 25,
  },
  {
    id: 109,
    item_id: "2-3-30",
    item_name: "三星通关30理智关卡(等效5次1-7)",
    item_value: 360,
    rarity: 5,
    type: "3_star",
    consume: 30,
  },
  {
    id: 110,
    item_id: "2-3-36",
    item_name: "三星通关36理智关卡(等效6次1-7)",
    item_value: 432,
    rarity: 5,
    type: "3_star",
    consume: 36,
  },
  {
    id: 111,
    item_id: "2-2-20",
    item_name: "二星通关20理智关卡",
    item_value: 200,
    rarity: 5,
    type: "2_star",
    consume: 20,
  },
  {
    id: 112,
    item_id: "2-2-25",
    item_name: "二星通关25理智关卡",
    item_value: 250,
    rarity: 5,
    type: "2_star",
    consume: 25,
  },
  {
    id: 113,
    item_id: "2-2-30",
    item_name: "二星通关30理智关卡",
    item_value: 300,
    rarity: 5,
    type: "2_star",
    consume: 30,
  },
  {
    id: 114,
    item_id: "2-2-36",
    item_name: "二星通关36理智关卡",
    item_value: 360,
    rarity: 5,
    type: "2_star",
    consume: 36,
  },
  {
    id: 115,
    item_id: "1-1-75-1",
    item_name: "对1名精一75级干员使用1次基础作战记录",
    item_value: -486,
    rarity: 1,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 116,
    item_id: "1-1-75-2",
    item_name: "对1名精一75级干员使用1次初级作战记录",
    item_value: -243,
    rarity: 2,
    type: "upgrade",
    consume: 0,
  },
  {
    id: 117,
    item_id: "5-1",
    item_name: "贸易站售卖2条赤金",
    item_value: 1000,
    rarity: 5,
    type: "trade",
    consume: 0,
  },
  {
    id: 118,
    item_id: "5-2",
    item_name: "贸易站售卖3条赤金",
    item_value: 1500,
    rarity: 5,
    type: "trade",
    consume: 0,
  },
  {
    id: 119,
    item_id: "5-3",
    item_name: "贸易站售卖4条赤金",
    item_value: 2000,
    rarity: 5,
    type: "trade",
    consume: 0,
  },
  {
    id: 120,
    item_id: "1-0-1",
    item_name: "对1名精零1级干员使用1次基础作战记录",
    item_value: -61,
    rarity: 1,
    type: "upgrade_only_0",
    consume: 0,
  },
  {
    id: 121,
    item_id: "1-0-2",
    item_name: "连续对1名精零1级干员使用2次基础作战记录",
    item_value: -125,
    rarity: 1,
    type: "upgrade_only_0",
    consume: 0,
  },
  {
    id: 122,
    item_id: "1-0-3",
    item_name: "连续对1名精零1级干员使用3次基础作战记录",
    item_value: -192,
    rarity: 1,
    type: "upgrade_only_0",
    consume: 0,
  },
  {
    id: 123,
    item_id: "1-0-4",
    item_name: "连续对1名精零1级干员使用4次基础作战记录",
    item_value: -262,
    rarity: 1,
    type: "upgrade_only_0",
    consume: 0,
  },
  {
    id: 124,
    item_id: "1-0-5",
    item_name: "连续对1名精零1级干员使用5次基础作战记录",
    item_value: -333,
    rarity: 1,
    type: "upgrade_only_0",
    consume: 0,
  },
  {
    id: 125,
    item_id: "1-0-6",
    item_name: "连续对1名精零1级干员使用6次基础作战记录",
    item_value: -407,
    rarity: 1,
    type: "upgrade_only_0",
    consume: 0,
  },
  {
    id: 126,
    item_id: "1-0-7",
    item_name: "连续对1名精零1级干员使用7次基础作战记录",
    item_value: -482,
    rarity: 1,
    type: "upgrade_only_0",
    consume: 0,
  },
  {
    id: 127,
    item_id: "1-0-8",
    item_name: "连续对1名精零1级干员使用8次基础作战记录",
    item_value: -559,
    rarity: 1,
    type: "upgrade_only_0",
    consume: 0,
  },
  {
    id: 128,
    item_id: "1-0-9",
    item_name: "连续对1名精零1级干员使用9次基础作战记录",
    item_value: -638,
    rarity: 1,
    type: "upgrade_only_0",
    consume: 0,
  },
  {
    id: 129,
    item_id: "1-0-10",
    item_name: "连续对1名精零1级干员使用10次基础作战记录",
    item_value: -718,
    rarity: 1,
    type: "upgrade_only_0",
    consume: 0,
  },
  {
    id: 130,
    item_id: "1-0-11",
    item_name: "连续对1名精零1级干员使用11次基础作战记录",
    item_value: -800,
    rarity: 1,
    type: "upgrade_only_0",
    consume: 0,
  },
  {
    id: 131,
    item_id: "1-0-12",
    item_name: "连续对1名精零1级干员使用12次基础作战记录",
    item_value: -883,
    rarity: 1,
    type: "upgrade_only_0",
    consume: 0,
  },
  {
    id: 132,
    item_id: "1-0-13",
    item_name: "连续对1名精零1级干员使用13次基础作战记录",
    item_value: -967,
    rarity: 1,
    type: "upgrade_only_0",
    consume: 0,
  },
  {
    id: 133,
    item_id: "1-0-14",
    item_name: "连续对1名精零1级干员使用14次基础作战记录",
    item_value: -1053,
    rarity: 1,
    type: "upgrade_only_0",
    consume: 0,
  },
  {
    id: 134,
    item_id: "1-0-15",
    item_name: "连续对1名精零1级干员使用15次基础作战记录",
    item_value: -1139,
    rarity: 1,
    type: "upgrade_only_0",
    consume: 0,
  },
  {
    id: 135,
    item_id: "1-0-16",
    item_name: "连续对1名精零1级干员使用16次基础作战记录",
    item_value: -1228,
    rarity: 1,
    type: "upgrade_only_0",
    consume: 0,
  },
  {
    id: 136,
    item_id: "1-0-17",
    item_name: "连续对1名精零1级干员使用17次基础作战记录",
    item_value: -1317,
    rarity: 1,
    type: "upgrade_only_0",
    consume: 0,
  },
  {
    id: 137,
    item_id: "1-0-18",
    item_name: "连续对1名精零1级干员使用18次基础作战记录",
    item_value: -1407,
    rarity: 1,
    type: "upgrade_only_0",
    consume: 0,
  },
  {
    id: 138,
    item_id: "1-0-19",
    item_name: "连续对1名精零1级干员使用19次基础作战记录",
    item_value: -1503,
    rarity: 1,
    type: "upgrade_only_0",
    consume: 0,
  },
  {
    id: 139,
    item_id: "1-0-20",
    item_name: "连续对1名精零1级干员使用20次基础作战记录",
    item_value: -1601,
    rarity: 1,
    type: "upgrade_only_0",
    consume: 0,
  },
  {
    id: 140,
    item_id: "1-0-21",
    item_name: "连续对1名精零1级干员使用21次基础作战记录",
    item_value: -1707,
    rarity: 1,
    type: "upgrade_only_0",
    consume: 0,
  },
  {
    id: 141,
    item_id: "1-0-22",
    item_name: "连续对1名精零1级干员使用22次基础作战记录",
    item_value: -1812,
    rarity: 1,
    type: "upgrade_only_0",
    consume: 0,
  },
  {
    id: 142,
    item_id: "1-0-23",
    item_name: "连续对1名精零1级干员使用23次基础作战记录",
    item_value: -1926,
    rarity: 1,
    type: "upgrade_only_0",
    consume: 0,
  },
  {
    id: 143,
    item_id: "1-0-24",
    item_name: "连续对1名精零1级干员使用24次基础作战记录",
    item_value: -2040,
    rarity: 1,
    type: "upgrade_only_0",
    consume: 0,
  },
  {
    id: 144,
    item_id: "1-0-25",
    item_name: "连续对1名精零1级干员使用25次基础作战记录",
    item_value: -2162,
    rarity: 1,
    type: "upgrade_only_0",
    consume: 0,
  },
  {
    id: 145,
    item_id: "1-0-26",
    item_name: "连续对1名精零1级干员使用26次基础作战记录",
    item_value: -2284,
    rarity: 1,
    type: "upgrade_only_0",
    consume: 0,
  },
  {
    id: 146,
    item_id: "1-0-27",
    item_name: "连续对1名精零1级干员使用27次基础作战记录",
    item_value: -2413,
    rarity: 1,
    type: "upgrade_only_0",
    consume: 0,
  },
  {
    id: 147,
    item_id: "1-0-28",
    item_name: "连续对1名精零1级干员使用28次基础作战记录",
    item_value: -2542,
    rarity: 1,
    type: "upgrade_only_0",
    consume: 0,
  },
  {
    id: 148,
    item_id: "1-0-29",
    item_name: "连续对1名精零1级干员使用29次基础作战记录",
    item_value: -2678,
    rarity: 1,
    type: "upgrade_only_0",
    consume: 0,
  },
  {
    id: 149,
    item_id: "1-0-30",
    item_name: "连续对1名精零1级干员使用30次基础作战记录",
    item_value: -2815,
    rarity: 1,
    type: "upgrade_only_0",
    consume: 0,
  },
  {
    id: 150,
    item_id: "1-1-1",
    item_name: "对1名精一1级干员使用1次基础作战记录",
    item_value: -81,
    rarity: 1,
    type: "upgrade_only_1",
    consume: 0,
  },
  {
    id: 151,
    item_id: "1-1-2",
    item_name: "连续对1名精一1级干员使用2次基础作战记录",
    item_value: -165,
    rarity: 1,
    type: "upgrade_only_1",
    consume: 0,
  },
  {
    id: 152,
    item_id: "1-1-3",
    item_name: "连续对1名精一1级干员使用3次基础作战记录",
    item_value: -251,
    rarity: 1,
    type: "upgrade_only_1",
    consume: 0,
  },
  {
    id: 153,
    item_id: "1-1-4",
    item_name: "连续对1名精一1级干员使用4次基础作战记录",
    item_value: -338,
    rarity: 1,
    type: "upgrade_only_1",
    consume: 0,
  },
  {
    id: 154,
    item_id: "1-1-5",
    item_name: "连续对1名精一1级干员使用5次基础作战记录",
    item_value: -427,
    rarity: 1,
    type: "upgrade_only_1",
    consume: 0,
  },
  {
    id: 155,
    item_id: "1-1-6",
    item_name: "连续对1名精一1级干员使用6次基础作战记录",
    item_value: -516,
    rarity: 1,
    type: "upgrade_only_1",
    consume: 0,
  },
  {
    id: 156,
    item_id: "1-1-7",
    item_name: "连续对1名精一1级干员使用7次基础作战记录",
    item_value: -607,
    rarity: 1,
    type: "upgrade_only_1",
    consume: 0,
  },
  {
    id: 157,
    item_id: "1-1-8",
    item_name: "连续对1名精一1级干员使用8次基础作战记录",
    item_value: -700,
    rarity: 1,
    type: "upgrade_only_1",
    consume: 0,
  },
  {
    id: 158,
    item_id: "1-1-9",
    item_name: "连续对1名精一1级干员使用9次基础作战记录",
    item_value: -793,
    rarity: 1,
    type: "upgrade_only_1",
    consume: 0,
  },
  {
    id: 159,
    item_id: "1-1-10",
    item_name: "连续对1名精一1级干员使用10次基础作战记录",
    item_value: -886,
    rarity: 1,
    type: "upgrade_only_1",
    consume: 0,
  },
  {
    id: 160,
    item_id: "1-1-11",
    item_name: "连续对1名精一1级干员使用11次基础作战记录",
    item_value: -982,
    rarity: 1,
    type: "upgrade_only_1",
    consume: 0,
  },
  {
    id: 161,
    item_id: "1-1-12",
    item_name: "连续对1名精一1级干员使用12次基础作战记录",
    item_value: -1077,
    rarity: 1,
    type: "upgrade_only_1",
    consume: 0,
  },
  {
    id: 162,
    item_id: "1-1-13",
    item_name: "连续对1名精一1级干员使用13次基础作战记录",
    item_value: -1175,
    rarity: 1,
    type: "upgrade_only_1",
    consume: 0,
  },
  {
    id: 163,
    item_id: "1-1-14",
    item_name: "连续对1名精一1级干员使用14次基础作战记录",
    item_value: -1273,
    rarity: 1,
    type: "upgrade_only_1",
    consume: 0,
  },
  {
    id: 164,
    item_id: "1-1-15",
    item_name: "连续对1名精一1级干员使用15次基础作战记录",
    item_value: -1371,
    rarity: 1,
    type: "upgrade_only_1",
    consume: 0,
  },
  {
    id: 165,
    item_id: "1-1-16",
    item_name: "连续对1名精一1级干员使用16次基础作战记录",
    item_value: -1471,
    rarity: 1,
    type: "upgrade_only_1",
    consume: 0,
  },
  {
    id: 166,
    item_id: "1-1-17",
    item_name: "连续对1名精一1级干员使用17次基础作战记录",
    item_value: -1570,
    rarity: 1,
    type: "upgrade_only_1",
    consume: 0,
  },
  {
    id: 167,
    item_id: "1-1-18",
    item_name: "连续对1名精一1级干员使用18次基础作战记录",
    item_value: -1671,
    rarity: 1,
    type: "upgrade_only_1",
    consume: 0,
  },
  {
    id: 168,
    item_id: "1-1-19",
    item_name: "连续对1名精一1级干员使用19次基础作战记录",
    item_value: -1772,
    rarity: 1,
    type: "upgrade_only_1",
    consume: 0,
  },
  {
    id: 169,
    item_id: "1-1-20",
    item_name: "连续对1名精一1级干员使用20次基础作战记录",
    item_value: -1874,
    rarity: 1,
    type: "upgrade_only_1",
    consume: 0,
  },
  {
    id: 170,
    item_id: "1-1-21",
    item_name: "连续对1名精一1级干员使用21次基础作战记录",
    item_value: -1976,
    rarity: 1,
    type: "upgrade_only_1",
    consume: 0,
  },
  {
    id: 171,
    item_id: "1-1-22",
    item_name: "连续对1名精一1级干员使用22次基础作战记录",
    item_value: -2081,
    rarity: 1,
    type: "upgrade_only_1",
    consume: 0,
  },
  {
    id: 172,
    item_id: "1-1-23",
    item_name: "连续对1名精一1级干员使用23次基础作战记录",
    item_value: -2185,
    rarity: 1,
    type: "upgrade_only_1",
    consume: 0,
  },
  {
    id: 173,
    item_id: "1-1-24",
    item_name: "连续对1名精一1级干员使用24次基础作战记录",
    item_value: -2289,
    rarity: 1,
    type: "upgrade_only_1",
    consume: 0,
  },
  {
    id: 174,
    item_id: "1-1-25",
    item_name: "连续对1名精一1级干员使用25次基础作战记录",
    item_value: -2395,
    rarity: 1,
    type: "upgrade_only_1",
    consume: 0,
  },
  {
    id: 175,
    item_id: "1-1-26",
    item_name: "连续对1名精一1级干员使用26次基础作战记录",
    item_value: -2502,
    rarity: 1,
    type: "upgrade_only_1",
    consume: 0,
  },
  {
    id: 176,
    item_id: "1-1-27",
    item_name: "连续对1名精一1级干员使用27次基础作战记录",
    item_value: -2608,
    rarity: 1,
    type: "upgrade_only_1",
    consume: 0,
  },
  {
    id: 177,
    item_id: "1-1-28",
    item_name: "连续对1名精一1级干员使用28次基础作战记录",
    item_value: -2714,
    rarity: 1,
    type: "upgrade_only_1",
    consume: 0,
  },
  {
    id: 178,
    item_id: "1-1-29",
    item_name: "连续对1名精一1级干员使用29次基础作战记录",
    item_value: -2823,
    rarity: 1,
    type: "upgrade_only_1",
    consume: 0,
  },
  {
    id: 179,
    item_id: "1-1-30",
    item_name: "连续对1名精一1级干员使用30次基础作战记录",
    item_value: -2931,
    rarity: 1,
    type: "upgrade_only_1",
    consume: 0,
  },
  {
    id: 180,
    item_id: "1-2-1",
    item_name: "连续对1名精二1级干员使用1次基础作战记录",
    item_value: -80,
    rarity: 1,
    type: "upgrade_only_2",
    consume: 0,
  },
  {
    id: 181,
    item_id: "1-2-2",
    item_name: "连续对1名精二1级干员使用2次基础作战记录",
    item_value: -162,
    rarity: 1,
    type: "upgrade_only_2",
    consume: 0,
  },
  {
    id: 182,
    item_id: "1-2-3",
    item_name: "连续对1名精二1级干员使用3次基础作战记录",
    item_value: -244,
    rarity: 1,
    type: "upgrade_only_2",
    consume: 0,
  },
  {
    id: 183,
    item_id: "1-2-4",
    item_name: "连续对1名精二1级干员使用4次基础作战记录",
    item_value: -328,
    rarity: 1,
    type: "upgrade_only_2",
    consume: 0,
  },
  {
    id: 184,
    item_id: "1-2-5",
    item_name: "连续对1名精二1级干员使用5次基础作战记录",
    item_value: -412,
    rarity: 1,
    type: "upgrade_only_2",
    consume: 0,
  },
  {
    id: 185,
    item_id: "1-2-6",
    item_name: "连续对1名精二1级干员使用6次基础作战记录",
    item_value: -497,
    rarity: 1,
    type: "upgrade_only_2",
    consume: 0,
  },
  {
    id: 186,
    item_id: "1-2-7",
    item_name: "连续对1名精二1级干员使用7次基础作战记录",
    item_value: -583,
    rarity: 1,
    type: "upgrade_only_2",
    consume: 0,
  },
  {
    id: 187,
    item_id: "1-2-8",
    item_name: "连续对1名精二1级干员使用8次基础作战记录",
    item_value: -670,
    rarity: 1,
    type: "upgrade_only_2",
    consume: 0,
  },
  {
    id: 188,
    item_id: "1-2-9",
    item_name: "连续对1名精二1级干员使用9次基础作战记录",
    item_value: -757,
    rarity: 1,
    type: "upgrade_only_2",
    consume: 0,
  },
  {
    id: 189,
    item_id: "1-2-10",
    item_name: "连续对1名精二1级干员使用10次基础作战记录",
    item_value: -844,
    rarity: 1,
    type: "upgrade_only_2",
    consume: 0,
  },
  {
    id: 190,
    item_id: "1-2-11",
    item_name: "连续对1名精二1级干员使用11次基础作战记录",
    item_value: -933,
    rarity: 1,
    type: "upgrade_only_2",
    consume: 0,
  },
  {
    id: 191,
    item_id: "1-2-12",
    item_name: "连续对1名精二1级干员使用12次基础作战记录",
    item_value: -1022,
    rarity: 1,
    type: "upgrade_only_2",
    consume: 0,
  },
  {
    id: 192,
    item_id: "1-2-13",
    item_name: "连续对1名精二1级干员使用13次基础作战记录",
    item_value: -1110,
    rarity: 1,
    type: "upgrade_only_2",
    consume: 0,
  },
  {
    id: 193,
    item_id: "1-2-14",
    item_name: "连续对1名精二1级干员使用14次基础作战记录",
    item_value: -1199,
    rarity: 1,
    type: "upgrade_only_2",
    consume: 0,
  },
  {
    id: 194,
    item_id: "1-2-15",
    item_name: "连续对1名精二1级干员使用15次基础作战记录",
    item_value: -1290,
    rarity: 1,
    type: "upgrade_only_2",
    consume: 0,
  },
  {
    id: 195,
    item_id: "1-2-16",
    item_name: "连续对1名精二1级干员使用16次基础作战记录",
    item_value: -1381,
    rarity: 1,
    type: "upgrade_only_2",
    consume: 0,
  },
  {
    id: 196,
    item_id: "1-2-17",
    item_name: "连续对1名精二1级干员使用17次基础作战记录",
    item_value: -1472,
    rarity: 1,
    type: "upgrade_only_2",
    consume: 0,
  },
  {
    id: 197,
    item_id: "1-2-18",
    item_name: "连续对1名精二1级干员使用18次基础作战记录",
    item_value: -1563,
    rarity: 1,
    type: "upgrade_only_2",
    consume: 0,
  },
  {
    id: 198,
    item_id: "1-2-19",
    item_name: "连续对1名精二1级干员使用19次基础作战记录",
    item_value: -1654,
    rarity: 1,
    type: "upgrade_only_2",
    consume: 0,
  },
  {
    id: 199,
    item_id: "1-2-20",
    item_name: "连续对1名精二1级干员使用20次基础作战记录",
    item_value: -1747,
    rarity: 1,
    type: "upgrade_only_2",
    consume: 0,
  },
  {
    id: 200,
    item_id: "1-2-21",
    item_name: "连续对1名精二1级干员使用21次基础作战记录",
    item_value: -1839,
    rarity: 1,
    type: "upgrade_only_2",
    consume: 0,
  },
  {
    id: 201,
    item_id: "1-2-22",
    item_name: "连续对1名精二1级干员使用22次基础作战记录",
    item_value: -1932,
    rarity: 1,
    type: "upgrade_only_2",
    consume: 0,
  },
  {
    id: 202,
    item_id: "1-2-23",
    item_name: "连续对1名精二1级干员使用23次基础作战记录",
    item_value: -2024,
    rarity: 1,
    type: "upgrade_only_2",
    consume: 0,
  },
  {
    id: 203,
    item_id: "1-2-24",
    item_name: "连续对1名精二1级干员使用24次基础作战记录",
    item_value: -2118,
    rarity: 1,
    type: "upgrade_only_2",
    consume: 0,
  },
  {
    id: 204,
    item_id: "1-2-25",
    item_name: "连续对1名精二1级干员使用25次基础作战记录",
    item_value: -2213,
    rarity: 1,
    type: "upgrade_only_2",
    consume: 0,
  },
  {
    id: 205,
    item_id: "1-2-26",
    item_name: "连续对1名精二1级干员使用26次基础作战记录",
    item_value: -2307,
    rarity: 1,
    type: "upgrade_only_2",
    consume: 0,
  },
  {
    id: 206,
    item_id: "1-2-27",
    item_name: "连续对1名精二1级干员使用27次基础作战记录",
    item_value: -2401,
    rarity: 1,
    type: "upgrade_only_2",
    consume: 0,
  },
  {
    id: 207,
    item_id: "1-2-28",
    item_name: "连续对1名精二1级干员使用28次基础作战记录",
    item_value: -2496,
    rarity: 1,
    type: "upgrade_only_2",
    consume: 0,
  },
  {
    id: 208,
    item_id: "1-2-29",
    item_name: "连续对1名精二1级干员使用29次基础作战记录",
    item_value: -2591,
    rarity: 1,
    type: "upgrade_only_2",
    consume: 0,
  },
  {
    id: 209,
    item_id: "1-2-30",
    item_name: "连续对1名精二1级干员使用30次基础作战记录",
    item_value: -2687,
    rarity: 1,
    type: "upgrade_only_2",
    consume: 0,
  },
  {
    id: 210,
    item_id: "2-3-12",
    item_name: "三星通关12理智关卡(等效2次1-7)",
    item_value: 144,
    rarity: 5,
    type: "3_star",
    consume: 12,
  },
  {
    id: 211,
    item_id: "2-2-12",
    item_name: "二星通关12理智关卡",
    item_value: 120,
    rarity: 5,
    type: "2_star",
    consume: 12,
  },
  {
    id: 212,
    item_id: "4-4",
    item_name: "活动商店使用7代币换取5000龙门币",
    item_value: 5000,
    rarity: 5,
    type: "store_5000",
    consume: 0,
  },
  {
    id: 213,
    item_id: "4-5",
    item_name: "活动商店使用7代币换取2000龙门币",
    item_value: 2000,
    rarity: 5,
    type: "store_2000",
    consume: 0,
  },
  {
    id: 214,
    item_id: "2-4-6",
    item_name: "通关CE-6获取10000龙门币",
    item_value: 10000,
    rarity: 5,
    type: "ce",
    consume: 36,
  },
  {
    id: 215,
    item_id: "2-4-5",
    item_name: "通关CE-5获取7500龙门币",
    item_value: 7500,
    rarity: 5,
    type: "ce",
    consume: 30,
  },
  {
    id: 216,
    item_id: "2-4-4",
    item_name: "通关CE-4获取5700龙门币",
    item_value: 5700,
    rarity: 5,
    type: "ce",
    consume: 25,
  },
  {
    id: 217,
    item_id: "2-4-3",
    item_name: "通关CE-3获取4100龙门币",
    item_value: 4100,
    rarity: 5,
    type: "ce",
    consume: 20,
  },
  {
    id: 218,
    item_id: "2-4-2",
    item_name: "通关CE-2获取2800龙门币",
    item_value: 2800,
    rarity: 5,
    type: "ce",
    consume: 15,
  },
  {
    id: 219,
    item_id: "2-4-1",
    item_name: "通关CE-1获取1700龙门币",
    item_value: 1700,
    rarity: 5,
    type: "ce",
    consume: 10,
  },
];

/**
 * 根据 id 获取物品信息
 * @param {number} id - 要查找的 id
 * @returns {Object|null} - 找到的物品信息，未找到则返回 null
 */
export const getItemById = (id) => {
  return classifyData.find((item) => item.id === id) || null;
};
